import { Injectable } from '@angular/core';
import { Logger } from '../utils/logger';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
// import { environment } from '../../environments/environment';
import { EnvironmentService } from '../configs/environment.service';

@Injectable({
  providedIn: 'root'
})
export class WebSocketSignalingService extends EventTarget {
  private websocket: WebSocket;
  public isWsOpen: boolean = false;
  private isWsOpen$: Subject<boolean> = new BehaviorSubject<boolean>(false);
  public connectionId: string | null = null;
  private typeOfConnection: string | null = null;
  heartbeatInterval: any = null;

  constructor(
    private environmentService: EnvironmentService
  ) {
    super();
    // let websocketUrl: string = environment.websocketUrl;
    let websocketUrl: string = environmentService.get('websocketUrl');
    if(!websocketUrl) {
      // let websocketHost: string = environment.websocketHost || location.host
      let websocketHost: string = environmentService.get('websocketHost') || location.host
      if (location.protocol === "https:") {
        websocketUrl = "wss://" + websocketHost;
      } else {
        websocketUrl = "ws://" + websocketHost;
      }
    }
    

    this.websocket = new WebSocket(websocketUrl);

    this.websocket.onopen = () => {
      this.isWsOpen = true;
      this.isWsOpen$.next(true);
      this.startHeartbeat();
    };

    this.websocket.onclose = () => {
      this.isWsOpen = false;
      this.isWsOpen$.next(false);
      this.stopHeartbeat();
    };

    this.websocket.onmessage = (event: MessageEvent) => {
      const msg = JSON.parse(event.data);
      if (!msg || !this) return;

      Logger.log(msg);

      switch (msg.type) {
        case "connect":
          this.dispatchEvent(new CustomEvent('connect', { detail: msg }));
          break;
        case "disconnect":
          this.dispatchEvent(new CustomEvent('disconnect', { detail: msg }));
          break;
        case "offer":
          this.dispatchEvent(new CustomEvent('offer', {
            detail: { connectionId: msg.from, sdp: msg.data.sdp, polite: msg.data.polite }
          }));
          break;
        case "answer":
          this.dispatchEvent(new CustomEvent('answer', {
            detail: { connectionId: msg.from, sdp: msg.data.sdp }
          }));
          break;
        case "candidate":
          this.dispatchEvent(new CustomEvent('candidate', {
            detail: { connectionId: msg.from, candidate: msg.data.candidate, sdpMLineIndex: msg.data.sdpMLineIndex, sdpMid: msg.data.sdpMid }
          }));
          break;
        case "connectOther":
          console.log('Other peer is connected to websocket...', msg);
          this.dispatchEvent(new CustomEvent('connectOther', {
            detail: msg
          }));
          break;
        default:
          break;
      }
    };
  }

  public startHeartbeat(): void {
    if(this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval);
    }
    this.heartbeatInterval = setInterval(() => {
      if(!this.isWsOpen) {
        return;
      }
      const sendJson = JSON.stringify({ type: "ping", data: { connectionId: this.connectionId } });
      Logger.log(sendJson);
      this.websocket.send(sendJson);
    }, 10000);
  }

  public stopHeartbeat(): void {
    if(this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval);
    }
  }

  public getIsWsOpen(): Observable<boolean> {
    return this.isWsOpen$;
  }

  private sleep(msec: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, msec));
  }

  start(): Promise<void> {
    return new Promise((resolve) => {
      this.isWsOpen$.subscribe((isWsOpen) => {
        if (isWsOpen) {
          resolve();
        }
      })
    })
  }

  stop(): Promise<void> {
    return new Promise((resolve) => {
      this.websocket.close();
      this.isWsOpen$.subscribe((isWsOpen) => {
        if (!isWsOpen) {
          resolve();
        }
      })
    })
    // while (this.isWsOpen) {
    //   await this.sleep(100);
    // }
  }

  createConnection(connectionId: string, typeOfConnection: string | null): void {
    this.typeOfConnection = typeOfConnection;
    const sendJson = JSON.stringify({ type: "connect", connectionId, typeOfConnection: this.typeOfConnection });
    Logger.log(sendJson);
    this.websocket.send(sendJson);
  }

  deleteConnection(connectionId: string): void {
    const sendJson = JSON.stringify({ type: "disconnect", connectionId, typeOfConnection: this.typeOfConnection });
    Logger.log(sendJson);
    this.websocket.send(sendJson);
  }

  sendOffer(connectionId: string, sdp: string): void {
    const data = { sdp, connectionId };
    const sendJson = JSON.stringify({ type: "offer", from: connectionId, data, typeOfConnection: this.typeOfConnection });
    Logger.log(sendJson);
    this.websocket.send(sendJson);
  }

  sendAnswer(connectionId: string, sdp: string): void {
    const data = { sdp, connectionId };
    const sendJson = JSON.stringify({ type: "answer", from: connectionId, data, typeOfConnection: this.typeOfConnection });
    Logger.log(sendJson);
    this.websocket.send(sendJson);
  }

  sendCandidate(connectionId: string, candidate: string, sdpMLineIndex: number, sdpMid: any): Promise<any | void> {
    return new Promise<any | void>((resolve, reject) => {
      const data = { candidate, sdpMLineIndex, sdpMid, connectionId };
      const sendJson = JSON.stringify({ type: "candidate", from: connectionId, data, typeOfConnection: this.typeOfConnection });
      Logger.log(sendJson);
      this.websocket.send(sendJson);
      resolve(true);
    })
    
  }
}
